import { useFlag } from '@unleash/proxy-client-react';
import React from 'react';
import {
  Navigate, Route, Routes,
} from 'react-router-dom';
import useGlobalStoreContext from '../../../Contexts/GlobalContext/Contexts/GlobalStoreContext/useGlobalStoreContext';
import useSessionContext from '../../../LiveContext/SessionContextProvider/useSessionContext';
import Suspense from '../../../Suspense';
import DecisionTreeWindow from '../../DecisionTreeWindow';
import PageErrorBoundary from './ErorrBoundary';
import NotificationPage from './Pages/NotificationPage';

const CardPage = React.lazy(() => import('./Pages/CardPage'));
const HomePage = React.lazy(() => import('./Pages/HomePage'));
const CardsPage = React.lazy(() => import('./Pages/CardsPage'));
const CommandPage = React.lazy(() => import('./Pages/CommandPage'));
const CompliancePage = React.lazy(() => import('./Pages/CompliancePage'));
const SettingsPage = React.lazy(() => import('./Pages/SettingsPage'));
const SearchPage = React.lazy(() => import('./SearchPage'));
const ContentRequestPage = React.lazy(() => import('./Pages/ContentRequestPage'));
const PerformancePage = React.lazy(() => import('./Pages/PerformancePage'));
const SessionsPage = React.lazy(() => import('./Pages/SessionsPage'));
const LiveSessionPage = React.lazy(() => import('./Pages/LiveSessionPage'));

export default function Router() {
  const summarySession = useFlag('summary-session');
  const { projectId: [projectId] } = useGlobalStoreContext();
  const { sessionId } = useSessionContext();

  if (!projectId) {
    return (
      <div>
        No project selected
      </div>
    );
  }

  return (
    <Routes>
      <Route path="home/*" element={(<Suspense><PageErrorBoundary><HomePage projectId={projectId} /></PageErrorBoundary></Suspense>)} />
      <Route path="decision-trees/*" element={<PageErrorBoundary><DecisionTreeWindow /></PageErrorBoundary>} />
      <Route path="search" element={(<Suspense><PageErrorBoundary><SearchPage /></PageErrorBoundary></Suspense>)} />
      <Route path="projects/:projectId/cards/:cardId" element={<Suspense><PageErrorBoundary><CardPage /></PageErrorBoundary></Suspense>} />
      <Route path="library/cards/:cardId" element={<Suspense><PageErrorBoundary><CardPage /></PageErrorBoundary></Suspense>} />
      <Route path="settings/*" element={<Suspense><PageErrorBoundary><SettingsPage /></PageErrorBoundary></Suspense>} />
      <Route path="requests/*" element={<Suspense><PageErrorBoundary><ContentRequestPage /></PageErrorBoundary></Suspense>} />
      <Route path="commands" element={<Suspense><PageErrorBoundary><CommandPage projectId={projectId} /></PageErrorBoundary></Suspense>} />
      <Route path="cards" element={<Suspense><PageErrorBoundary><CardsPage projectId={projectId} /></PageErrorBoundary></Suspense>} />
      <Route path="compliance/*" element={<Suspense><PageErrorBoundary><CompliancePage projectId={projectId} /></PageErrorBoundary></Suspense>} />
      <Route path="performance/*" element={<Suspense><PageErrorBoundary><PerformancePage /></PageErrorBoundary></Suspense>} />
      <Route path="notifications/:id" element={<PageErrorBoundary><NotificationPage /></PageErrorBoundary>} />
      <Route path="live-session" element={(<Suspense><PageErrorBoundary extraResetKeys={[sessionId]}><LiveSessionPage /></PageErrorBoundary></Suspense>)} />
      {summarySession && <Route path="sessions/*" element={<Suspense><PageErrorBoundary><SessionsPage /></PageErrorBoundary></Suspense>} />}
      <Route path="*" element={<Navigate to="/home/content" replace />} />
    </Routes>
  );
}
